import { Pressable, Text, type TextStyle, View } from 'react-native'
import { convertLineHeight, convertPercentageToNumber } from '~/utils'

import { styled } from '~/utils/styled'

export const Root = styled(View, theme => {
  return {
    base: {
      gap: theme.spacingStackFourpulse,
    },
    variants: {},
  }
})

export const Content = styled(View, theme => {
  return {
    base: {
      paddingTop: theme.paddingInsetSixpulse,
      backgroundColor: theme.colorContainerFillDefault,
    },
    variants: {
      isCollapsed: {
        true: {
          position: 'absolute',
          opacity: 0,
        },
      },
    },
  }
})

export const Item = styled(Pressable, theme => {
  return {
    base: {
      minWidth: 184,
      maxWidth: '100%',
      borderColor: theme.colorContainerBorderDefault,
      borderWidth: theme.borderWidthQuarterpulse,
      borderRadius: theme.borderRadiusMediumcontainer,
      padding: theme.spacingInlineFourpulse,
      backgroundColor: theme.colorContainerFillDefault,
    },
    variants: {},
  }
})

export const Header = styled(View, theme => {
  return {
    base: {
      borderRadius: theme.borderRadiusNone,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: theme.spacingInlineTwopulse,
      padding: theme.paddingInsetNone,
      width: '100%',
    },
    variants: {},
  }
})

export const Title = styled(Text, theme => {
  const baseFontWeight = String(theme.fontWeightBold) as TextStyle['fontWeight']
  return {
    base: {
      color: theme.colorTextNeutralDefault,
      fontSize: theme.fontSizeFourpulse,
      fontWeight: baseFontWeight,
      lineHeight: convertLineHeight(
        theme.fontSizeFourpulse,
        theme.lineHeightSmall
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      flex: 1,
    },
    variants: {},
  }
})
